<template>
  <div class="upload">
    <home-header :isShow="true"></home-header>
    <div class="center">
      <comment-title :titleText="title_text" :isShow="false"></comment-title>
      <div class="uplaod_img">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item
            :prop="'htype'"
            v-if="is_multi == 1"
            :label="`文件类型`"
          >
            <el-select
              v-model="ruleForm['htype']"
              :placeholder="`请选择文件类型`"
              @change="currentSel"
            >
              <el-option :label="`音频文件`" :value="1"></el-option>
              <el-option :label="`视频文件`" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <div v-for="(item, index) of activity_info" :key="index">
            <el-form-item
              :prop="index"
              v-if="
                item.is_select == 1 && item.type == 'file' && index == 'image'
              "
              :label="item.name"
            >
              <el-upload
                list-type="picture-card"
                action="#"
                :limit="imgNum"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :before-upload="beforeImageUpload"
                :http-request="httpRequest"
                :file-list="fmurl"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <span style="color: #999;">（请选取jpg、png图片）</span>
              <el-dialog :visible.sync="dialogVisible">
                <img class="img_fit" width="100%" :src="dialogImageUrl" alt />
              </el-dialog>
            </el-form-item>

            <el-form-item
              :prop="index"
              v-if="
                item.is_select == 1 && item.type == 'file' && index == 'file'
              "
              :label="item.name"
            >
              <div class="box" v-if="type == 1">
                <el-upload
                  id="audioUpload"
                  class="avatar-uploader"
                  action="#"
                  :show-file-list="true"
                  :multiple="false"
                  :on-remove="handleAudioRemove"
                  :limit="1"
                  :auto-upload="true"
                  :before-upload="beforeAvatarUpload"
                  :http-request="upLoadMedia"
                >
                  <el-button slot="trigger" size="small" type="primary">{{
                    item.placeholder
                  }}</el-button>
                  <div
                    v-if="type == '1'"
                    slot="tip"
                    class="el-upload__tip"
                    style="margin-bottom: 10px"
                  >
                    请选择mp3音频文件
                  </div>
                  <div
                    v-else-if="type == '2'"
                    slot="tip"
                    class="el-upload__tip"
                    style="margin-bottom: 10px"
                  >
                    请选择mp4视频文件
                  </div>
                </el-upload>
              </div>
              <ChunkUpload
                v-if="type == 2"
                :value.sync="ruleForm[index]"
                @getVideoimage="onGetVideoimage"
              ></ChunkUpload>
            </el-form-item>

            <el-form-item
              :prop="index"
              v-if="item.is_select == 1 && item.type == 'text'"
              :label="item.name"
            >
              <el-select
                v-if="index == 'from'"
                v-model="ruleForm[index]"
                :placeholder="item.placeholder"
                @change="changeFrom"
                filterable
                remote
                :remote-method="remoteMethod"
              >
                <el-option
                  v-for="(v, index) of ogran_list"
                  :label="v.name"
                  :value="v.name"
                  :key="index"
                ></el-option>
              </el-select>
              <el-input
                v-else
                :placeholder="item.placeholder"
                v-model="ruleForm[index]"
              ></el-input>
            </el-form-item>
            <el-form-item
              :prop="index"
              v-if="
                item.is_select == 1 &&
                  (item.type == 'select' || item.type == 'radio')
              "
              :label="item.name"
            >
              <el-select
                v-model="ruleForm[index]"
                :placeholder="item.placeholder"
              >
                <el-option
                  v-for="(v, index) of item.option"
                  :label="v"
                  :value="v"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              :prop="index"
              v-if="item.is_select == 1 && item.type == 'textarea'"
              :label="item.name"
            >
              <editor v-if="type == 3" @func="getEditor"></editor>
              <el-input
                v-else
                :placeholder="item.placeholder"
                :rows="8"
                type="textarea"
                v-model="ruleForm[index]"
              ></el-input>
            </el-form-item>
          </div>

          <el-form-item>
            <el-button type="primary" @click="changeData('ruleForm')"
              >确定</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>

    <home-footer></home-footer>
  </div>
</template>
<script>
//   import HomeHeader from '@/components/Header';
import HomeHeader from "@/components/homeHeader";
import ChunkUpload from "@/components/ChunkUpload/index.vue"; // 上传组件

import HomeFooter from "@/components/Footer";
import CommentTitle from "@/components/Title";
import Editor from "./component/editor";
import { ACTIVITY_TYPE } from "../constant/index.js";

import MP4Box from "mp4box";
import { USER } from "../constant/storage";

import { fetchDepartment, fetchUploadImage } from "@/request/api_index.js";
export default {
  name: "Upload",
  components: {
    HomeHeader,
    HomeFooter,
    CommentTitle,
    Editor,
    ChunkUpload
  },
  data() {
    return {
      activity_info: [],
      placetext: "请输入",
      imgNum: 1,
      fmurl: [],
      dialogImageUrl: "",
      dialogVisible: false,
      selectObject: {},
      type: "",
      is_multi: 0,
      ogran_list: "",
      ruleForm: {
        activity_id: "",
        file: "",
        from: "",
        name: "",
        text: "",
        type: "",
        group: "",
        image: "",
        phone: "",
        organize: "",
        username: "",
        department: "",
        textarea: "",
        filed_1: "",
        filed_2: "",
        htype: ""
      },
      rules: {},
      activity_type: 0,
      title_text: "",
      field_data: {},

      // 院系
      departmentOptions: []
    };
  },
  computed: {
    isShow_426() {
      return this.ruleForm.filed_3 === "研究所";
    },
    filedList() {
      let result = [];
      console.log("字段列表");
      for (let el in this.activity_info) {
        result.push({
          ...this.activity_info[el],
          key: el
        });
      }
      result.sort((a, b) => {
        console.log(a, b);
        return a.sort - b.sort;
      });
      console.log(result);
      return result;
    }
  },
  mounted() {
    this.activity_type = +localStorage.getItem("activity-type");
    this.setTitleByType();

    this.getField();
    this.getOgran();
  },
  methods: {
    setTitleByType() {
      if (this.activity_type === ACTIVITY_TYPE.vote) {
        this.title_text = `填写报名信息`;
      } else {
        this.title_text = `上传作品信息`;
      }
    },

    async doVoteSign() {
      try {
        let imgurl = [];
        for (let el of this.fmurl) {
          imgurl.push(el.url);
        }
        this.ruleForm.image = JSON.stringify(imgurl);
        console.log("=============", this.ruleForm);
        let res = await this.$api.fetchVoteSign({
          data: this.ruleForm
        });
        this.$message({
          message: "提交成功",
          type: "success"
        });
        this.$router.go(-1); //返回上一层

        console.log("success", res);
      } catch (err) {
        console.error("fail", err);
      }
    },

    //征文富文本内容
    getEditor(data) {
      if (this.type == 3) {
        this.ruleForm.text = data;
        console.log(this.ruleForm.text, 111);
      }
    },

    //获取上传字段
    getField() {
      let id = this.$route.params.id;
      this.ruleForm.activity_id = id;
      this.$api
        .activityField({ id: id })
        .then(res => {
          //数据处理
          this.activity_info = res.data.field_json;
          console.log("字段");
          console.log(this.activity_info);
          this.field_data = res.data;
          // this.handDepartment();
          if (res.data.type != 10) {
            this.type = res.data.type;
          } else {
            this.is_multi = 1; //是视频加音频活动
          }

          if (res.data.type == 4) {
            this.imgNum = 3;
          }

          for (let index in res.data.field_json) {
            let obj = {};
            let arr = [];
            if (res.data.field_json[index].is_required) {
              obj = {
                required: true,
                message: "请输入" + res.data.field_json[index].name
              };
              arr.push(obj);
              this.$set(this.rules, index, arr);
            }
          }
          if (res.data.type == 10) {
            let obj = {};
            let arr = [];
            obj = { required: true, message: "请选择文件类型" };
            arr.push(obj);
            console.log(arr);
            this.$set(this.rules, "htype", arr);
          }
          //
          this.setDefaultValue();
        })
        .catch(err => console.log(err));
    },
    getOgran() {
      let id = this.$route.params.id;
      this.$api
        .activityOgran({ id: id })
        .then(res => {
          //数据处理
          this.ogran_list = res.data;
        })
        .catch(err => console.log(err));
    },
    remoteMethod(e) {
      let id = this.$route.params.id;

      console.log("remoteMethod", e);
      this.$api
        .activityOgran({
          id: id,
          keyword: e
        })
        .then(res => {
          this.ogran_list = res.data;
        })
        .catch(err => {
          console.error(err);
        });
    },

    // 上传图片相关事件
    handleRemove(file, fileList) {
      // this.fmurl
      for (var i = 0; i < this.fmurl.length; i++) {
        console.log(this.fmurl[i].uid, file.uid);
        if (this.fmurl[i].uid == file.uid) {
          this.fmurl.splice(i, 1);
          this.$message("删除图片成功!");
        } else {
        }
      }
      console.log(this.fmurl, "删除图片");
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeImageUpload(file) {
      console.log(file);
      // 文件类型进行判断
      const isImg = file.type === "image/png" || file.type === "image/jpeg";
      // 限制上传文件大小 5M
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isImg) {
        this.$message.error("上传图片只能是jpg或者png格式!");
      }
      if (!isLt5M) {
        this.$message.error("上传文件大小不能超过 5MB!");
      }
      return isImg && isLt5M;
    },
    httpRequest(file) {
      let params = new FormData();
      params.append("file", file.file);
      this.$api
        .uploadImage(params)
        .then(res => {
          //数据处理
          this.fmurl.push({ uid: file.file.uid, url: res.data.url });
          this.ruleForm.image = res.data.url;
          console.log(this.fmurl, "上传后返回");
        })
        .catch(err => console.log(err));
    },
    // 上传音频文件相关事件
    async beforeAvatarUpload(file) {
      if (this.type == 1) {
        // 文件类型进行判断
        const isAudio = file.type === "audio/mp3" || file.type === "audio/mpeg";
        // 限制上传文件大小 2M
        // const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isAudio) {
          this.$message.error("上传文件只能是Mp3格式!");
          return Promise.reject();
        }
        return isAudio;
      } else if (this.type == 2) {
        // 文件类型进行判断
        const isVideo = file.type === "video/mp4" || file.type === "video/mpeg";
        // 限制上传文件大小 2M
        // const isLt2M = file.size / 1024 / 1024 < 2;
        const isLt5M = file.size / 1024 / 1024 < 800;
        console.log("上传视频", file.size, isLt5M);
        if (!isVideo) {
          this.$message.error("上传文件只能是Mp4格式!");
          return Promise.reject();
        }
        if (!isLt5M) {
          this.$message.error("上传文件大小不能超过800MB!");
          return Promise.reject();
        }
        //
        let isCode = false;
        console.log("start==");

        console.log("bb");
        let result = await this.checkVideoCode(file);
        console.log("result", result);
        if (result.mime.includes("hvc1")) {
          this.$message.error("上传文件的编码格式错误!");
          return Promise.reject();
        } else {
          isCode = true;
        }
      }
    },

    checkVideoCode(file) {
      return new Promise((resolve, reject) => {
        const mp4boxFile = MP4Box.createFile();
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = function(e) {
          const arrayBuffer = e.target.result;
          arrayBuffer.fileStart = 0;
          mp4boxFile.appendBuffer(arrayBuffer);
        };
        mp4boxFile.onReady = function(info) {
          resolve(info);
        };
        mp4boxFile.onError = function(info) {
          reject(info);
        };
      });
    },

    upLoadMedia(file) {
      console.log("上传", file);
      let params = new FormData();
      params.append("file", file.file);
      if (this.type == 1) {
        this.$api
          .uploadAudio(params)
          .then(res => {
            //数据处理
            this.ruleForm.file = res.data.url;
            console.log(res.data.url, this.ruleForm.file, "上传后返回");
          })
          .catch(err => console.log(err));
      } else if (this.type == 2) {
          console.log('params',params)
        this.$api
          .uploadVideo(params)
          .then(res => {
            //数据处理
            this.ruleForm.file = res.data.url;
            console.log(res.data.url, this.ruleForm.file, "上传后返回");
          })
          .catch(err => console.log(err));
      }
    },

    handleAudioRemove(file, fileList) {
      console.log("删除文件");
      this.ruleForm.file = "";
      console.log(this.ruleForm.file);
    },

    // 下拉框
    currentSel(selVal) {
      this.type = selVal;
      console.log(selVal);
    },

    //
    changeFrom(value) {
      console.log("value", value);
      let list = this.ogran_list.filter(item => {
        return item.name == value;
      });
      console.log("ddd", list);
      this.ruleForm.department = "";
      fetchDepartment({
        data: {
          id: list[0].id
        },
        isLoading: true
      })
        .then(res => {
          //
          let list = res.data.map(item => {
            return item.name;
          });
          this.departmentOptions = res.data;
          this.activity_info.department.option = list;
          console.log("院系", list, this.activity_info);
        })
        .catch(err => {
          //
        });
    },
    //完成
    changeData(form) {
      console.log(this.ruleForm);
      this.$refs[form].validate(valid => {
        console.log(valid);
        if (valid) {
          // console.log('====||', +this.type , ACTIVITY_TYPE.vote);

          if (ACTIVITY_TYPE.vote === +this.activity_type) {
            this.doVoteSign();
          } else {
            this.onSubmit();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 上传
    onSubmit() {
      var that = this;
      console.log("上传");
      var imgurl = [];
      for (var i = 0; i < this.fmurl.length; i++) {
        imgurl.push(this.fmurl[i].url);
      }
      this.ruleForm.image = JSON.stringify(imgurl);
      if (this.ruleForm.file && Array.isArray(this.ruleForm.file)) {
        this.ruleForm.file = this.ruleForm.file[0].url;
      }
      this.$api
        .submitForm(that.ruleForm)
        .then(res => {
          console.log(res);
          if (res.code == 200) {
            this.$message({
              message: "上传成功，正在快马加鞭审核...",
              type: "success"
            });
            this.$router.go(-1); //返回上一层
          }
        })
        .catch(err => console.log(err));
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //
    setDefaultValue() {
      //
      let userinfo = JSON.parse(localStorage.getItem(USER));
      console.log("user", userinfo);
      this.ruleForm.username = userinfo.username;
      this.ruleForm.phone = userinfo.mobile;
    },
    async onGetVideoimage(frame) {
      console.log("获取视频封面", frame);
      // this.fmurl.push({ uid: 1, url: frame.url });
      // if(this.fmurl)

      let imgFile = new File([frame.blob], "thumb_img.png");
      let res = await this.uploadImage(imgFile);
      console.log("res", res);
      this.ruleForm.image = res.url;

      if (this.fmurl.length > 0) {
        // this.fmurl.splice(0,1);
        this.fmurl = [
          {
            uid: Date.now(),
            url: res.url
          },
          ...this.fmurl.slice(1)
        ];
      } else {
        this.fmurl.push({
          uid: Date.now(),
          url: res.url
        });
      }
    },
    // 上传图片
    async uploadImage(file) {
      try {
        let formdata = new FormData();
        formdata.append("file", file);
        let res = await fetchUploadImage({
          data: formdata
        });
        return res.data;
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>
<style scoped>
.upload /deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  object-fit: contain;
}
.img_fitP {
  object-fit: cover;
}
.upload {
  background: #f3f3f3;
  width: 100%;
  height: 100%;
}
.center {
  width: 1200px;
  margin: 20px auto 20px auto;
  padding: 20px;
  box-sizing: border-box;
}
.uplaod_img {
  margin-top: 20px;
}
.el-form-item__label {
  text-align: left;
}

@media (min-width: 1024px) {
  .uplaod_img >>> input {
    height: 50px;
  }
  .el-form-item {
    margin-bottom: 40px;
  }
} /*>=1024的设备*/

@media (min-width: 1100px) {
} /*>=1100的设备*/
@media (min-width: 1280px) {
  .uplaod_img >>> input {
    height: auto;
  }
  .el-form-item {
    margin-bottom: 25px;
  }
} /*>=1280的设备*/
</style>



// WEBPACK FOOTER //
// src/upload/Upload.vue